import { OperatortoMethodMapType } from './types';

export const OperatorToMethodMap: OperatortoMethodMapType = {
  OR: 'some',
  EQUALS: 'some',
  AND: 'every',
};
